// Import dependencies
import React, { createElement, useState } from "react";
import { NavLink } from "react-router-dom";

// Import motion library
import { motion } from "framer-motion";

// Import lottie components
import Gear from "../Lotties/Gear";

// Import data content
import { content } from "../assets/data/Content";

// Import components
import Helmet from "../components/Helmet/Helmet";
import StudiesCard from "../components/AboutMe/StudiesCard";
import WorksCard from "../components/AboutMe/WorksCard";

// Import styles
import { Row, Col, Container } from "reactstrap";

const AboutMe = () => {
  // Content
  const { aboutMe } = content;

  // Change tab
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <>
      <Helmet title="Sobre Mi">
        <main className="bg-bg_light_primary h-[100vh]">
          <div className="bg-bg_light_primary h-auto">
            {/* Title & Subtitle */}
            <div className="p-8 m-0">
              <h2 className="title" data-aos="fade-left">
                {aboutMe.title}
              </h2>

              <h4 className="subtitle" data-aos="fade-right">
                {aboutMe.subtitle}
              </h4>
            </div>

            <div className="flex flex-col">
              {/* Toggle Studies */}
              <div className="flex justify-center mb-[1rem] gap-10">
                <div
                  className={
                    toggleState === 1
                      ? "cursor-pointer text-dark_primary button--flex"
                      : "cursor-pointer text-gray button--flex"
                  }
                  onClick={() => toggleTab(1)}
                >
                  <i className="text-[20px] flex gap-2 items-center font-Inria not-italic">
                    {createElement(aboutMe.iconStudies)} Educación
                  </i>
                </div>

                <div
                  className={
                    toggleState === 2
                      ? "cursor-pointer text-dark_primary"
                      : "cursor-pointer text-gray"
                  }
                  onClick={() => toggleTab(2)}
                >
                  <i className="text-[20px] flex gap-2 items-center font-Inria not-italic">
                    {createElement(aboutMe.iconWork)} Trabajo
                  </i>
                </div>
              </div>
              {/* Timeline */}
              <div className=" max-h-[100%] py-1 flex flex-col justify-center sm:py-12">
                {/* Studies */}
                <div
                  className={
                    toggleState === 1
                      ? "py-3 sm:max-w-xl sm:mx-auto w-full px-2 sm:px-0 block"
                      : "py-3 sm:max-w-xl sm:mx-auto w-full px-2 sm:px-0 hidden"
                  }
                >
                  <div className="relative text-gray-700 antialiased text-sm font-semibold">
                    {/* Vertical bar of middle */}
                    <div className="hidden sm:block w-[1px] bg-gray absolute h-full left-1/2 transform -translate-x-1/2"></div>

                    {/* Studies Card */}
                    {aboutMe.studiesContent.map((study, index) =>
                      study.position === "left" ? (
                        <motion.div
                          initial={{
                            x: -100,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          animate={{
                            x: 0,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          key={index}
                        >
                          <div className="mt-6 sm:mt-0 sm:mb-12">
                            <div className="flex flex-col sm:flex-row items-center">
                              <div className="flex justify-start w-full mx-auto items-center">
                                <div className="w-full sm:w-1/2 sm:pr-8">
                                  <div className="p-4 bg-white_txt rounded shadow">
                                    <StudiesCard study={study} />
                                  </div>
                                </div>
                              </div>

                              <div className="rounded-full bg-dark_primary border-0 w-8 h-8 absolute left-1/2 -translate-y-4 sm:translate-y-0 transform -translate-x-1/2 flex items-center justify-center text-[20px] text-white_txt">
                                {createElement(aboutMe.iconStudies)}
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      ) : (
                        <motion.div
                          initial={{
                            x: 100,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          animate={{
                            x: 0,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          key={index}
                        >
                          <div className="mt-6 sm:mt-0 sm:mb-12">
                            <div className="flex flex-col sm:flex-row items-center">
                              <div className="flex justify-end w-full mx-auto items-center">
                                <div className="w-full sm:w-1/2 sm:pl-8">
                                  <div className="p-4 bg-white_txt rounded shadow">
                                    <StudiesCard study={study} />
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-full bg-dark_primary border-0 w-8 h-8 absolute left-1/2 -translate-y-4 sm:translate-y-0 transform -translate-x-1/2 flex items-center justify-center text-[20px] text-white_txt">
                                {createElement(aboutMe.iconStudies)}
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      )
                    )}
                  </div>
                </div>
                {/* /Studies */}

                {/* Work */}
                <div
                  className={
                    toggleState === 2
                      ? "py-3 sm:max-w-xl sm:mx-auto w-full px-2 sm:px-0 block"
                      : "py-3 sm:max-w-xl sm:mx-auto w-full px-2 sm:px-0 hidden"
                  }
                >
                  <div className="relative text-gray-700 antialiased text-sm font-semibold">
                    {/* Vertical bar of middle */}
                    <div className="hidden sm:block w-[1px] bg-gray absolute h-full left-1/2 transform -translate-x-1/2"></div>

                    {/* Works Card */}
                    {aboutMe.workContent.map((work, index) =>
                      work.position === "left" ? (
                        <motion.div
                          initial={{
                            x: -100,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          animate={{
                            x: 0,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          key={index}
                        >
                          <div className="mt-6 sm:mt-0 sm:mb-12">
                            <div className="flex flex-col sm:flex-row items-center">
                              <div className="flex justify-start w-full mx-auto items-center">
                                <div className="w-full sm:w-1/2 sm:pr-8">
                                  <div className="p-4 bg-white_txt rounded shadow">
                                    <WorksCard work={work} />
                                  </div>
                                </div>
                              </div>

                              <div className="rounded-full bg-dark_primary border-0 w-8 h-8 absolute left-1/2 -translate-y-4 sm:translate-y-0 transform -translate-x-1/2 flex items-center justify-center text-[20px] text-white_txt">
                                {createElement(aboutMe.iconWork)}
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      ) : (
                        <motion.div
                          initial={{
                            x: 100,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          animate={{
                            x: 0,
                            transition: {
                              type: "spring",
                              duration: 1.5,
                              delay: 1,
                            },
                          }}
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          key={index}
                        >
                          <div className="mt-6 sm:mt-0 sm:mb-12">
                            <div className="flex flex-col sm:flex-row items-center">
                              <div className="flex justify-end w-full mx-auto items-center">
                                <div className="w-full sm:w-1/2 sm:pl-8">
                                  <div className="p-4 bg-white_txt rounded shadow">
                                    <WorksCard work={work} />
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-full bg-dark_primary border-0 w-8 h-8 absolute left-1/2 -translate-y-4 sm:translate-y-0 transform -translate-x-1/2 flex items-center justify-center text-[20px] text-white_txt">
                                {createElement(aboutMe.iconWork)}
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      )
                    )}
                  </div>
                </div>
                {/* /Work */}
              </div>{" "}
              {/* /Timeline */}
            </div>

            {/* Description */}
            <Container>
              <Row>
                <Col lg={12}>
                  <main className="p-[3rem] mt-3">
                    <p className="text-justify m-0">
                      Hola, mi nombre es{" "}
                      <span className="font-bold">
                        Nicolás Santiago Naranjo
                      </span>{" "}
                      soy{" "}
                      <span className="font-bold">Ingeniero Industrial</span> de
                      Bogotá - Colombia.
                    </p>

                    <p className="text-justify mt-4">
                      Me he desempeñado laboralmente en diferentes sectores
                      económicos y áreas de mi carrera profesional, desde el
                      área de Planeación, Producción y Logística, hasta el
                      diseño e implementación de Sistemas de Gestión basados en
                      la Norma ISO 9001:2015.
                    </p>

                    <p className="text-justify mt-4">
                      En búsqueda de mi crecimiento profesional y el poder
                      adquirir nuevos conocimientos realice una Tecnología en{" "}
                      <span className="font-bold">
                        Análisis y Desarrollo de Sistemas de Información
                      </span>{" "}
                      (Desarrollo de Software), conocimientos que me llevaron a
                      amar la programación y hacer una integración profesional
                      enfocándome en la mejora de procesos e ideas de negocio a
                      través del desarrollo web.
                    </p>

                    <p className="text-justify mt-4">
                      Esta experiencia profesional me motivó a ser Desarrollador
                      Web a través de mi marca personal{" "}
                      <span className="font-bold">WirkiSoft</span>.
                    </p>
                  </main>
                </Col>
              </Row>
            </Container>

            {/* Link to return home page */}
            <NavLink
              to={"/home"}
              className="block fixed right-[-2rem] bottom-0 h-[120px] z-[1]"
            >
              <Gear />
            </NavLink>
          </div>
        </main>
      </Helmet>
    </>
  );
};

export default AboutMe;
